import type { XYChartChartLegendProps } from '../types/xy-chart-props.js';

export const Legend = (props: XYChartChartLegendProps) => null;

Legend['displayName'] = 'XYChartChart.Legend';
